// extracted by mini-css-extract-plugin
module.exports = {"reward":"CartPoints_reward__VLhe7"};